interface IHandleCatchIssueUseCase {
  errorName: string;
  error: any;
  userEmail?: string;
  extras?: any;
  userId?: string;
}

// Sentry.init({
//   dsn: 'https://495ec17b62994fdea49dba9aa85904aa@o428316.ingest.sentry.io/5815600',
//   denyUrls: [
//     // Chrome extensions
//     /extensions\//i,
//     /^chrome:\/\//i,
//   ],
//   ignoreErrors: ['node.getElementsByTagName is not a function'],
//   allowUrls: ['maisretorno.com'],
//   enabled: process.env.NODE_ENV === 'production',
// });

export interface ICatchIssueUseCase {
  handle(params: IHandleCatchIssueUseCase): void;
}

export class CatchIssueUseCase implements ICatchIssueUseCase {
  constructor() {}

  handle({
    errorName,
    error,
    extras = {},
    userEmail = null,
    userId = null,
  }: IHandleCatchIssueUseCase): void {
    return // stop sentry
    // try {
    //   Sentry.captureException(error, (scope) => {
    //     scope.setUser({ email: userEmail, id: userId });
    //     scope.setTransactionName(errorName);
    //     scope.setExtras({ ...extras, error });

    //     return scope;
    //   });
    // } catch (error) {
    //   console.log('Error on handle catch issue use case', error);
    // }
  }
}
